// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/popover/style.scss
// module id = 410
// module chunks = 0 1